import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormGroup, Label } from 'reactstrap';

import { dataContractApi } from '../../../../helpers/api/dataContractApi';
import { MeasurementUnitText } from '../../../../helpers/enums/measurementUnitEnum';
import RequiredStarLabel from '../../../common/requiredStarLabel';
import EntitySelect from '../../../entitySelect/EntitySelect';
import FormGroupNote from '../../FormGroupNote';

export default function MeasurementUnitSelect({
  isRequired = false,
  isDisabled
}) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <FormGroup>
      <Label htmlFor="measurementUnit">
        {t('Measurement Unit')} {isRequired && <RequiredStarLabel />}
      </Label>
      <Controller
        name="measurementUnit"
        control={control}
        render={({ field }) => (
          <EntitySelect
            name="measurementUnit"
            displayName={t('Measurement Unit')}
            fieldValue={field.value}
            onChange={field.onChange}
            placeholder="Not specified"
            fetchDataFunction={() => {
              return dataContractApi.getDataContractsByContractType(
                'measurement-units'
              );
            }}
            isFetchDataEnum
            enumToText={MeasurementUnitText}
            isDisabled={isDisabled}
          />
        )}
      />
      {errors.measurementUnit && (
        <FormGroupNote type={'warning'}>
          {errors.measurementUnit.message}
        </FormGroupNote>
      )}
    </FormGroup>
  );
}
